export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "数据字典明细详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "字典项名称：",
            type: "input",
            value: "zdxmc",
            maxlength: 60,
            rule: {
              required: true,
              message: "请填写字典项名称",
              trigger: "blur"
            }
          },
          {
            label: "字典项代码：",
            type: "input",
            value: "zdxdm",
            maxlength: 60,
            rule: {
              required: true,
              message: "请填写字典项代码",
              trigger: "blur"
            }
          },
          {
            label: "所属字典：",   
            type: "select",
            value: "zdid",
            required: true,
            rule: {
              required: true,
              message: "请选择所属字典",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/Combobox",
              table: "V2_DATA_DICTIONARY_",
              value: "ID_",
              name: "ZDMC_",
            }
          },
          {
            label: "作废标志：",
            type: "select",
            value: "zfbz",
            required: true,
            rule: {
              required: true,
              message: "请选择作废标志",
              trigger: "change"
            },
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201610190958144723",
            }
          },
        ]
      },
    ];
  }
}
